import React, { useContext } from "react";
import { ToastContext } from "../context/ToastContext";

export const withToastContext = (BaseComponent) => {
  return (props) => {
    const toastContext = useContext(ToastContext);
    return <BaseComponent toastContext={toastContext} {...props} />;
  };
};
